import { request } from './core.api';

export interface OnboardingStatusDto {
  isCompleted: boolean;
}

export interface ImportOnboardingCsvRequest {
  content: string;
}

export interface OnboardingCsvImportResultDto {
  importedRowCount: number;
  createdPropertyCount: number;
  createdTenantCount: number;
  firstPropertyId?: string;
  firstTenantId?: string;
}

export const onboardingApi = {
  getStatus: () => request<OnboardingStatusDto>('/onboarding/status'),
  complete: () => request<void>('/onboarding/complete', { method: 'POST' }),
  importCsv: (data: ImportOnboardingCsvRequest) =>
    request<OnboardingCsvImportResultDto>('/onboarding/import-csv', { method: 'POST', body: JSON.stringify(data) }),
};
